var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-60663296"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "custom-tooltip" };
import { clamp, sortedIndex } from 'lodash';
import { ref, watch, computed, nextTick } from 'vue';
import VueSlider from 'vue-slider-component';
import 'vue-slider-component/theme/antd.css';
import { MILLISECONDS_PER_MINUTE } from '../../constants';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ChronoSlider',
    props: {
        startsAt: {
            type: Number,
            required: true,
        },
        endsAt: {
            type: Number,
            required: true,
        },
        timestamps: {
            type: Array,
            required: true,
        },
    },
    emits: ['change'],
    setup: function (__props, _a) {
        var _this = this;
        var emits = _a.emit;
        var props = __props;
        var timestamp = ref(props.timestamps.length > 0 ? props.timestamps[0] : props.startsAt);
        var marks = computed(function () {
            var marks = [];
            var date = new Date(props.startsAt);
            date.setSeconds(0);
            date.setMinutes(0);
            while (date.getTime() <= props.endsAt) {
                marks.push(date.getTime());
                date = new Date(date.getTime() + 30 * MILLISECONDS_PER_MINUTE);
            }
            return marks;
        });
        var url = new URL(window.location.href);
        var urlTimestamp = url.searchParams.get('timestamp');
        if (urlTimestamp) {
            timestamp.value = Date.parse(urlTimestamp);
        }
        emits('change', timestamp.value);
        function updateWindowHref(stringTimestamp) {
            if (stringTimestamp) {
                var url_1 = new URL(window.location.href);
                url_1.searchParams.set('timestamp', stringTimestamp);
                window.history.replaceState(null, '', url_1.href);
            }
        }
        watch(timestamp, function (value, prevValue) { return __awaiter(_this, void 0, void 0, function () {
            var timestampIdx, direction, idx, stringTimestamp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        timestampIdx = sortedIndex(props.timestamps, value);
                        if (!(props.timestamps[timestampIdx] !== timestamp.value)) return [3 /*break*/, 2];
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        direction = value > prevValue ? 0 : -1;
                        idx = clamp(timestampIdx + direction, 0, props.timestamps.length - 1);
                        timestamp.value = props.timestamps[idx];
                        return [3 /*break*/, 3];
                    case 2:
                        emits('change', timestamp.value);
                        stringTimestamp = new Date(timestamp.value).toISOString();
                        updateWindowHref(stringTimestamp);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        }); });
        var hourFormatter = new Intl.DateTimeFormat('en-CA', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hourCycle: 'h23',
        });
        function timestampToHour(value) {
            var date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return String(value);
            }
            return hourFormatter.format(date);
        }
        var halfHourFormatter = new Intl.DateTimeFormat('en-CA', {
            hour: '2-digit',
            minute: '2-digit',
            second: undefined,
            hourCycle: 'h23',
        });
        function timestampToHalfHour(value) {
            var date = new Date(value);
            if (Number.isNaN(date.getTime())) {
                return String(value);
            }
            return halfHourFormatter.format(date);
        }
        return function (_ctx, _cache) {
            return (__props.timestamps.length > 0)
                ? (_openBlock(), _createBlock(_unref(VueSlider), {
                    key: 0,
                    modelValue: timestamp.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((timestamp).value = $event); }),
                    marks: marks.value,
                    lazy: true,
                    contained: true,
                    min: __props.startsAt,
                    max: __props.endsAt
                }, {
                    label: _withCtx(function (_a) {
                        var label = _a.label, active = _a.active;
                        return [
                            _createElementVNode("div", {
                                class: _normalizeClass(['vue-slider-mark-label', 'custom-label', { active: active }])
                            }, _toDisplayString(timestampToHalfHour(label)), 3 /* TEXT, CLASS */)
                        ];
                    }),
                    tooltip: _withCtx(function (_a) {
                        var value = _a.value;
                        return [
                            _createElementVNode("div", _hoisted_1, _toDisplayString(timestampToHour(value)), 1 /* TEXT */)
                        ];
                    }),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "marks", "min", "max"]))
                : _createCommentVNode("v-if", true);
        };
    }
});
